import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import useGetPostsDetails from 'src/hook/useGetPostDetails'
import { useCommunityDetails } from 'src/pages/CommunityDetails/Posts/context/communityDetailsContext'
import { useAICreateCompletion } from '../useAICreateCompletion'
import { useAIGetCompletion } from '../useAIGetCompletion'
import {
  AISuggestion,
  PathParams,
  UseAICommentSuggestionsProps
} from './useAICommentSuggestions.types'

const useAICommentSuggestions = ({ enabled }: UseAICommentSuggestionsProps) => {
  const { idPost } = useParams() as PathParams
  const [uuid, setUuid] = useState<string>()
  const { community } = useCommunityDetails()
  const [aISuggestions, setAISuggestions] = useState<AISuggestion[]>()
  const { isLoading: isLoadingPostDetails, data: post } = useGetPostsDetails({
    id: Number(idPost),
    enabled,
    communityType: community.type
  })

  const mutation = useAICreateCompletion({
    postText: post?.description || post?.title || '',
    onSuccess: setUuid
  })

  const { data: aiCompletion, isLoading: isLoadingAICompletion } = useAIGetCompletion(
    uuid as string
  )

  const isValidPostText = Boolean(post?.description || post?.title)

  useEffect(() => {
    if (enabled && isValidPostText) {
      mutation.mutate()
    }
  }, [enabled, post])

  useEffect(() => {
    if (aiCompletion?.text) {
      try {
        const cleanedText = aiCompletion.text.replace(/```json|```/g, '').trim()
        const { comments } = JSON.parse(cleanedText)
        const suggestions = comments.map((comment: string) => ({
          comment,
          option: 'AI_COMMENT_SUGGESTION'
        }))

        setAISuggestions(suggestions)
      } catch {
        setAISuggestions([])
      }
    }
  }, [aiCompletion])

  return {
    loading: isLoadingPostDetails || isLoadingAICompletion,
    aISuggestions
  }
}

export default useAICommentSuggestions
